import { Nullable } from '@/utils/types';
import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';

// Private contacts come back with masked phones; a masked value must never become a link.
export const MASKED_VALUE = '*****';

// Links the raw number and leaves formatting to the display text, as the rest of the app does.
export const getCustomFieldPhoneHref = (value: Nullable<string>): Nullable<string> => {
  return isValuePresent(value) && value !== MASKED_VALUE ? `tel:${value}` : null;
};
